import HistoryIndex from './history-index';

export default class HistoryIndexDesktop extends HistoryIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/history/history-index.desktop.js